<template>
	<div class="agreement">
		<infoHeader :title="title" icon="el-icon-document"></infoHeader>
		<div class="fixation">
			<div class="title">
				{{articleTitle}}
			</div>
			<div class="content">
				<div class="rich-text" v-html="nodes"></div>
			</div>
		</div>
		<pubfooter></pubfooter>
		<floatButton :current="1"></floatButton>
	</div>
</template>

<script>
	export default {
		name: '',
		data() {
			return {
				title: '',
				articleTitle: '',
				nodes: '',
				id: ''
			};
		},
		methods: {
			fetchData() {
				this.$api.frontArticleDetail({
					articleId: this.id
				}, res => {
					if (res.code == 200) {
						let article = res.data[0]
						this.articleTitle = article.articleName
						this.nodes = article.articleContent
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
			this.id = this.$route.query.id
			if (this.id == '005e993ee1844ee2a1c98439de175d4a') {
				this.title = '竞买协议'
			}
			if (this.id == '72beccc591c349528934ff34b832befb') {
				this.title = '大德拍卖平台隐私政策'
			}
			if (this.id == '1961d643e0dc4c83b98b005eb7e8303b') {
				this.title = '用户注册协议'
			}
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchData()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.title{
		width: 100%;
		height:100px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: @vue-font-size-base;
		font-weight: bold;
		margin-top: @vue-spacing-col-lg;
	}
	.content{
		margin-bottom: @vue-spacing-col-lg;
	}
</style>
